import { render, staticRenderFns } from "./ChaptersList.vue?vue&type=template&id=4f298a8f&scoped=true&"
import script from "./ChaptersList.vue?vue&type=script&lang=ts&"
export * from "./ChaptersList.vue?vue&type=script&lang=ts&"
import style0 from "./ChaptersList.vue?vue&type=style&index=0&id=4f298a8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f298a8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4f298a8f', component.options)
    } else {
      api.reload('4f298a8f', component.options)
    }
    module.hot.accept("./ChaptersList.vue?vue&type=template&id=4f298a8f&scoped=true&", function () {
      api.rerender('4f298a8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/courses/CoursePage/components/ChaptersList.vue"
export default component.exports